import { ConfigProvider } from 'antd'
import ruRU from 'antd/locale/ru_RU'
import React, { FC, PropsWithChildren } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'

import { QueryProvider } from './query'
import { UserProjectProvider } from './user-project/user-project.provider'
import inputConfig from '../../configs/theme-tokens'
import { AuthProvider } from '../../modules/auth/auth.context'
import { GlobalErrorProvider } from '../errors/providers/global-error-provider'

export const Providers: FC<PropsWithChildren> = ({ children }) => {
  return (
    <>
      <ConfigProvider
        locale={ruRU}
        theme={inputConfig}
      >
        <GlobalErrorProvider>
          <AuthProvider>
            <QueryProvider>
              <BrowserRouter>
                <UserProjectProvider>{children}</UserProjectProvider>
              </BrowserRouter>
            </QueryProvider>
          </AuthProvider>
        </GlobalErrorProvider>
      </ConfigProvider>
      <ToastContainer
        autoClose={2000}
        position="top-right"
        rtl={false}
        closeOnClick
        draggable
        pauseOnFocusLoss
        pauseOnHover
      />
    </>
  )
}
